export default "__VITE_ASSET__7f385497__"